import {
  createReceiver,
  createUpdater,
  createSender
} from '@/resource/resource'

import {
  prefixAPI,
} from '@/resource/api'

const MODEL = 'accounts/current'
const SINGLE_MODEL = 'accounts'

const ACCOUNT_DATA_LINK = prefixAPI('/receive/', MODEL)
const ACCOUNT_DELETE = prefixAPI('/delete/', SINGLE_MODEL)
const PERSONAL_DATA_UPDATE_LINK = prefixAPI('/update/', MODEL)

// const EMAIL_CHANGE_REQUEST_LINK = prefixAPI('/email/change/request/', MODEL)
// const EMAIL_CONFIRM_LINK = prefixAPI('/email/change/confirm/', MODEL)
// const EMAIL_CHANGE_LINK = prefixAPI('/email/change/', MODEL)

// const PRHONE_CHANGE_REQUEST_LINK = prefixAPI('/phone/change/request/', MODEL)
// const PRHONE_CONFIRM_LINK = prefixAPI('/phone/change/confirm/', MODEL)
// const PRHONE_CHANGE_LINK = prefixAPI('/phone/change/', MODEL)

export const accountDataResource = createReceiver(ACCOUNT_DATA_LINK)
export const accountUpdateResource = createUpdater(PERSONAL_DATA_UPDATE_LINK)
export const accountDeleteResource = createSender(ACCOUNT_DELETE)
// export const emailChangeRequestResource = createSender(EMAIL_CHANGE_REQUEST_LINK)
// export const emailConfirmResource = createSender(EMAIL_CONFIRM_LINK)
// export const emailUpdateResource = createSender(EMAIL_CHANGE_LINK)

// export const phoneChangeRequestResource = createSender(PRHONE_CHANGE_REQUEST_LINK)
// export const phoneConfirmResource = createSender(PRHONE_CONFIRM_LINK)
// export const phoneUpdateResource = createSender(PRHONE_CHANGE_LINK)